const GROUP_BY_OPTIONS = {
  INTEGRATION: 'integration',
  PIPELINE: 'pipeline',
};

export default GROUP_BY_OPTIONS;
